'use strict'
import {getInsigts} from './networking'

export class InsightsDataCache {
  constructor(insightsType) {
    this.insightsType = insightsType
    this.items = []
    this.nextUrl = null
    this.resources = {
      'segments--consumers': 'consumer-insights',
      'segments--trends': 'trend-insights'
    }
    this.endpoint = `/cmsapi/v1/${this.resources[insightsType]}/`
    this.isGettingData = false
  }
  next() {
    const item = this.items.splice(Math.floor(Math.random() * this.items.length), 1)[0]

    if (!this.items.length) {
      this.getItems()
    }

    return item
  }
  getItems() {
    const url = this.nextUrl ? this.nextUrl : this.endpoint
    this.isGettingData = true

    return new Promise(res => {
      getInsigts(url).then(data => {
        this.items = data.results
        this.nextUrl = data.next
        this.isGettingData = false
        res(this.items)
      })
    })
  }
}
